import { httpPlain } from "@/libraries";
export default {
  async getV3Channel() {
    return await httpPlain.get("/v3/channel");
  },
};
